import { render, staticRenderFns } from "./DraggableListsManageCardItem.vue?vue&type=template&id=1547cb36&scoped=true&"
import script from "./DraggableListsManageCardItem.vue?vue&type=script&lang=js&"
export * from "./DraggableListsManageCardItem.vue?vue&type=script&lang=js&"
import style0 from "./DraggableListsManageCardItem.vue?vue&type=style&index=0&id=1547cb36&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1547cb36",
  null
  
)

export default component.exports